module.exports = __webpack_public_path__ + "v1.0.0/img/success@3x.4941b8d.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/window/images/success@3x.png
// module id = LbtU
// module chunks = 8 9 11